var id = 0;

class SocketClientFile {
    constructor(socket, options) {
        this.instanceId = id++;		// using for identifying multiple file upload from SocketIOFileClient objects
        this.uploadId = 0;						// using for identifying each uploading
        this.ev = {};							// event handlers
        this.options = options || {};
        this.accepts = [];
        this.maxFileSize = undefined;
        this.socket = socket;
        this.uploadingFiles = {};
        this.isDestroyed = false;
        this.socketIOFileReciever();
        this.socketIOFileReq();
        this.socketIODisconnect();
    }

    socketIOFileReciever() {
        this.socket.on('socket.io-file::recvSync', function (settings) {
            console.log("setting>>", settings)
            this.maxFileSize = settings.maxFileSize || undefined;
            this.accepts = settings.accepts || [];
            this.chunkSize = settings.chunkSize || 10240;
            this.transmissionDelay = settings.transmissionDelay || 0;

            this.emit('ready');
        });

    }
    socketIOFileReq() {
        this.socket.emit('socket.io-file::reqSync');
    }

    socketIODisconnect() {
        this.socket.on('socket.io-file::disconnectByServer', function () {
            // self.emit('disconnected');
            // self.destroy();
        });
    }

    getUploadId() {
        return 'u_' + this.uploadId++;
    }

    upload(fileEl, options) {
        if (this.isDestroyed) {
            throw new Error('SocketIOFileClient is closed.');
        }

        if (!fileEl ||
            (fileEl.files && fileEl.files.length <= 0) ||
            fileEl.length <= 0
        ) {
            this.emit('error', new Error('No file(s) to upload.'));
            return [];
        }

        var self = this;
        var uploadIds = [];

        var files = fileEl.files ? fileEl.files : fileEl;
        var loaded = 0;
        console.log("OOOOOOsfsf", files)
        for (var i = 0; i < files.length; i++) {
            var file = files[i];
            var uploadId = this.getUploadId();
            uploadIds.push(uploadId);

            file.uploadId = uploadId;

            this._uploadIonic.call(self, file, options);
        }

        return uploadIds;
    }

    on(evName, fn) {
        if (this.isDestroyed) {
            throw new Error('SocketIOFileClient is closed.');
        }

        if (!this.ev[evName]) {
            this.ev[evName] = [];
        }

        this.ev[evName].push(fn);
        return this;
    }

    off(evName, fn) {
        if (this.isDestroyed) {
            throw new Error('SocketIOFileClient is closed.');
        }

        if (typeof evName === 'undefined') {
            this.ev = [];
        }
        else if (typeof fn === 'undefined') {
            if (this.ev[evName]) {
                delete this.ev[evName];
            }
        }
        else {
            var evList = this.ev[evName] || [];

            for (var i = 0; i < evList.length; i++) {
                if (evList[i] === fn) {
                    evList = evList.splice(i, 1);
                    break;
                }
            }
        }

        return this;
    };
    emit(evName) {
        if (this.isDestroyed) {
            throw new Error('SocketIOFileClient is closed.');
        }

        var evList = this.ev[evName] || [];

        var args = Array.from(arguments);
        args.splice(0, 1);			// Don't pass evName to the event handler.

        for (var i = 0; i < evList.length; i++) {
            evList[i].apply(null, args);
        }

        return this;
    };
    abort(id) {
        if (this.isDestroyed) {
            throw new Error('SocketIOFileClient is closed.');
        }

        var socket = this.socket;
        this.socket.emit('socket.io-file::abort::' + id);
    };
    destroy() {
        if (this.isDestroyed) {
            throw new Error('SocketIOFileClient is closed.');
        }

        var uploadingFiles = this.uploadingFiles;

        for (var key in uploadingFiles) {
            this.abort(key);
        }

        this.socket = null;
        this.uploadingFiles = null;
        this.ev = null;
        this.isDestroyed = true;
    };
    getUploadInfo() {
        return JSON.parse(JSON.stringify(this.uploadingFiles));
    };

    _upload(file, options) {
        options = options || {};

        var self = this;
        var socket = this.socket;
        var chunkSize = this.chunkSize || 204800;
        var transmissionDelay = this.transmissionDelay;
        var uploadId = file.uploadId;
        var uploadTo = options.uploadTo || '';
        var data = options.data || {};
        var fileInfo = {
            id: uploadId,
            name: file.name,
            size: file.size,
            chunkSize: chunkSize,
            sent: 0,
            data: data
        };
        console.log("uuuuuuuuuyychunkyyyy",fileInfo,chunkSize,uploadId,data,options)

        uploadTo && (fileInfo.uploadTo = uploadTo);

        // read file
        var fileReader = new FileReader();

        fileReader.onloadstart = function() {
            self.emit('loadstart');
        };

        fileReader.onprogress = function(progress) {
            self.emit('progress', {
                loaded: progress.loaded,
                total: progress.total
            });
        };

        fileReader.onloadend = function() {
            var buffer = fileReader.result;

            // check file mime type if exists
            if(self.accepts && self.accepts.length > 0) {
                var found = false;

                for(var i = 0; i < self.accepts.length; i++) {
                    var accept = self.accepts[i];

                    if(file.type === accept) {
                        found = true;
                        break;
                    }
                }

                if(!found) {
                    return self.emit('error', 
                        new Error('Not Acceptable file type ' + file.type + ' of ' + file.name + '. Type must be one of these: ' + self.accepts.join(', ')),
                        {
                            uploadId: fileInfo.id,
                            name: fileInfo.name, 
                            size: fileInfo.size,
                            type: file.type,
                            uploadTo: uploadTo,
                            data: data
                         }
                    );
                }
            }

            // check file size
            if(self.maxFileSize && self.maxFileSize > 0) {
                if(file.size > +self.maxFileSize) {
                    return self.emit('error', 
                        new Error('Max Uploading File size must be under ' + self.maxFileSize + ' byte(s).'),
                            {
                                uploadId: fileInfo.id,
                                name: fileInfo.name, 
                                size: fileInfo.size,
                                uploadTo: uploadTo,
                                data: data
                            }
                        );
                }
            }

            // put into uploadingFiles list
            self.uploadingFiles[uploadId] = fileInfo;

            // request the server to make a file
            self.emit('start', { 
                uploadId: fileInfo.id,
                name: fileInfo.name, 
                size: fileInfo.size,
                uploadTo: uploadTo,
                data: data
            });
            socket.emit('socket.io-file::createFile', fileInfo);

            function sendChunk() {
                if(fileInfo.aborted) {
                    return;
                }

                if(fileInfo.sent >= buffer.byteLength) {
                    socket.emit('socket.io-file::done::' + uploadId);
                    return;
                }

                var chunk = buffer.slice(fileInfo.sent, fileInfo.sent + chunkSize);

                console.log("chunksize>>>",chunkSize)
                self.emit('stream', { 
                    uploadId: fileInfo.id,
                    name: fileInfo.name, 
                    size: fileInfo.size, 
                    sent: fileInfo.sent,
                    uploadTo: uploadTo,
                    data: data
                });
                socket.once('socket.io-file::request::' + uploadId, sendChunk);
                socket.emit('socket.io-file::stream::' + uploadId, chunk);

                fileInfo.sent += chunk.byteLength;
                self.uploadingFiles[uploadId] = fileInfo;
            }
            socket.once('socket.io-file::request::' + uploadId, sendChunk);
            socket.on('socket.io-file::complete::' + uploadId, function(info) {
                info.uploadId = fileInfo.id;
                info.data = fileInfo.data;
                
                socket.removeAllListeners('socket.io-file::abort::' + uploadId);
                socket.removeAllListeners('socket.io-file::error::' + uploadId);
                socket.removeAllListeners('socket.io-file::complete::' + uploadId);

                // remove from uploadingFiles list
                delete self.uploadingFiles[uploadId];

                self.emit('complete', info);
            });
            socket.on('socket.io-file::abort::' + uploadId, function(info) {
                fileInfo.aborted = true;
                self.emit('abort', { 
                    uploadId: fileInfo.id,
                    name: fileInfo.name, 
                    size: fileInfo.size, 
                    sent: fileInfo.sent, 
                    wrote: info.wrote,
                    uploadTo: uploadTo,
                    data: data
                });
            });
            socket.on('socket.io-file::error::' + uploadId, function(err) {
                self.emit('error', 
                    new Error(err.message),
                    {
                        uploadId: fileInfo.id,
                        name: fileInfo.name, 
                        size: fileInfo.size,
                        uploadTo: uploadTo,
                        data: data
                    }
                );
            });
        };
        fileReader.readAsArrayBuffer(file);
    }
    _uploadIonic(file, options) {
        options = options || {};
    
        var self = this;
        var socket = this.socket;
        var chunkSize = this.chunkSize || 204800; // e.g., 200 KB
        var uploadId = file.uploadId;
        var uploadTo = options.uploadTo || '';
        var data = options.data || {};
    
        var fileInfo = {
            id: uploadId,
            name: file.name,
            size: file.size,
            chunkSize: chunkSize,
            sent: 0,
            data: data
        };
    
        // Initial Emit
        self.emit('start', { 
            uploadId: fileInfo.id,
            name: fileInfo.name, 
            size: fileInfo.size,
            uploadTo: uploadTo,
            data: data
        });
    
        socket.emit('socket.io-file::createFile', fileInfo);
    
        // This function handles the chunk uploading
        async function sendChunk() {
            if (fileInfo.aborted) return;
            
            // Check if all chunks are sent
            if (fileInfo.sent >= file.size) {
                socket.emit('socket.io-file::done::' + uploadId);
                return;
            }
    
            // Get the next chunk
            var chunk = file.slice(fileInfo.sent, fileInfo.sent + chunkSize);
    
            // Read chunk as an ArrayBuffer
            const buffer = await chunk.arrayBuffer();
            socket.once('socket.io-file::request::' + uploadId, sendChunk);
            socket.emit('socket.io-file::stream::' + uploadId, buffer);
    
            fileInfo.sent += chunk.size;
    
            // Emit progress event
            self.emit('stream', { 
                uploadId: fileInfo.id,
                name: fileInfo.name, 
                size: fileInfo.size, 
                sent: fileInfo.sent,
                uploadTo: uploadTo,
                data: data
            });
        }
    
        // Start the upload
        socket.once('socket.io-file::request::' + uploadId, sendChunk);
    
        // Handle completion
        socket.on('socket.io-file::complete::' + uploadId, function(info) {
            info.uploadId = fileInfo.id;
            info.data = fileInfo.data;
            delete self.uploadingFiles[uploadId];
            self.emit('complete', info);
        });
    
        // Handle abort
        socket.on('socket.io-file::abort::' + uploadId, function(info) {
            fileInfo.aborted = true;
            self.emit('abort', { 
                uploadId: fileInfo.id,
                name: fileInfo.name, 
                size: fileInfo.size, 
                sent: fileInfo.sent, 
                wrote: info.wrote,
                uploadTo: uploadTo,
                data: data
            });
        });
    
        // Handle errors
        socket.on('socket.io-file::error::' + uploadId, function(err) {
            self.emit('error', 
                new Error(err.message),
                {
                    uploadId: fileInfo.id,
                    name: fileInfo.name, 
                    size: fileInfo.size,
                    uploadTo: uploadTo,
                    data: data
                }
            );
        });
    }
}


export default SocketClientFile